/* eslint-disable */
export default {
  to: '宛先：',
  transferTo: '転送先',
  blindTransfer: '転送',
  warmTransfer: '最初に聞く',
  enterNameOrNumber: '番号を入力',
  toVoicemail: 'ボイスメールへ',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To voicemail"@#@
